import React from "react";

import { HardwareInfo } from "../../../../../api/graphql/devices/devices";
import { DeviceInformation } from "../../../../Workplaces/EditWorkplace/EditDevice/types";
import { SectionHeader } from "../ui/SectionHeader";
import { InfoList } from "../ui/InfoList";
import { Notice } from "../ui/Notice";

type HardwareRows = DeviceInformation["hardwareInfo"];

const LABELS: Array<keyof HardwareRows> = [
  "Brand / model",
  "Serial number",
  "Android OS",
  "Build number",
  "Resolution / DPI",
  "IP address",
  "MAC address",
];

// "a / b", with "-" for a missing half; undefined when both are missing
const joinPair = (first?: string, second?: string) =>
  first || second ? `${first || "-"} / ${second || "-"}` : undefined;

export const toHardwareInfo = (
  hardware: Partial<HardwareInfo>,
  androidOS?: string
): HardwareRows => ({
  "Brand / model": joinPair(hardware.brand, hardware.model),
  "Serial number": hardware.serialNumber,
  "Android OS": androidOS,
  "Build number": hardware.firmwareVersion,
  "Resolution / DPI": joinPair(
    hardware.resultion?.replace(/(\d)\s*x\s*(\d)/i, "$1 × $2"),
    hardware.dpi
  ),
  "IP address": hardware.ip,
  "MAC address": hardware.mac,
});

interface Props {
  // null when the device is unassigned or has no data yet
  hardware: HardwareRows | null;
}

export const HardwareSection = ({ hardware }: Props) => (
  <section className="DeviceSection HardwareSection">
    <SectionHeader icon="chip" title="Hardware" />

    {hardware ? (
      <InfoList
        items={LABELS.map((label) => ({ label, value: hardware[label] }))}
      />
    ) : (
      <Notice tone="muted">Unassigned or no data found.</Notice>
    )}
  </section>
);
